import { Tweet as BaseTweet } from 'react-tweet'
import type { ComponentProps } from 'react'

const NotFound = () => <></>

export const Tweet = (props: ComponentProps<typeof BaseTweet>) => {
  if (process.env.NEXT_PUBLIC_DISABLE_TWEETS === 'true') {
    return null
  }

  return (
    <BaseTweet
      {...props}
      onError={() => null}
      components={{ TweetNotFound: NotFound }}
    />
  )
}
